import { render, staticRenderFns } from "./BaseAbsoluteFotos.vue?vue&type=template&id=3fcc1a24&"
import script from "./BaseAbsoluteFotos.vue?vue&type=script&lang=js&"
export * from "./BaseAbsoluteFotos.vue?vue&type=script&lang=js&"
import style0 from "./BaseAbsoluteFotos.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports